const NSFW_KEY = 'klichat.nsfw'

export function nsfwAcceptedFor(channelId: string): boolean {
  try {
    return (JSON.parse(localStorage.getItem(NSFW_KEY) ?? '[]') as string[]).includes(channelId)
  } catch {
    return false
  }
}

export function rememberNsfw(channelId: string) {
  try {
    const list = JSON.parse(localStorage.getItem(NSFW_KEY) ?? '[]') as string[]
    if (!list.includes(channelId)) localStorage.setItem(NSFW_KEY, JSON.stringify([...list, channelId]))
  } catch {
    /* приватный режим */
  }
}

